export const UPLOAD_EXCEL_DATA_MUTATION = `
  mutation UploadExcelData($reportId: String!, $tableId: String!, $data: JSON!) {
    uploadExcelData(reportId: $reportId, tableId: $tableId, data: $data) {
      success
      message
      status
      data
    }
  }
`;

export const UPSERT_EXCEL_DATA_MUTATION = `
  mutation UpsertExcelData($reportId: String!, $tableId: String!, $data: JSON!) {
    upsertExcelData(reportId: $reportId, tableId: $tableId, data: $data) {
      success
      message
      status
      data
    }
  }
`;

export const UPDATE_EXCEL_DATA_MUTATION = `
  mutation UpdateExcelData($id: ID!, $data: JSON!) {
    updateExcelData(id: $id, data: $data) {
      success
      message
      status
      data
    }
  }
`;

export const DELETE_EXCEL_DATA_MUTATION = `
  mutation DeleteExcelData($id: ID!) {
    deleteExcelData(id: $id) {
      success
      message
      status
    }
  }
`;

export const DELETE_EXCEL_DATA_BY_REPORT_MUTATION = `
  mutation DeleteExcelDataByReport($reportId: String!, $tableId: String) {
    deleteExcelDataByReport(reportId: $reportId, tableId: $tableId) {
      success
      message
      status
      data
    }
  }
`;
